export function getAllListItemNodes(listItemsSelector: string): NodeListOf<HTMLElement> {
    return document.querySelectorAll<HTMLElement>(listItemsSelector);
}

export function getCurrentlyFocusableListItemNode(listItemsSelector: string): HTMLElement | null {
    return document.querySelector(`${listItemsSelector}[tabindex="0"]`);
}

export function getIndexOfListItemNode(
    listElements: NodeListOf<Element>,
    listItemNode: Element
): number {
    return Array.prototype.indexOf.call(listElements, listItemNode);
}

export function resetFocusToFirstListItem(listItemsSelector: string): void {
    const allListItems = getAllListItemNodes(listItemsSelector);
    allListItems.forEach(item => {
        if (item) {
            item.tabIndex = -1;
        }
    });
    if (allListItems?.[0]) {
        allListItems[0].tabIndex = 0;
    }
}
